export default {
    state: {
        props: []
    },
    actions: {
    },
    mutations: {
        setProps(state, props) {
            state.props = props;
        },
        setPropValue(state, {value, code}) {
            const prop = state.props.find(prop => prop.code === code);
            prop.value = value;
        },
    },
    getters: {},
    namespaced: true
}